var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_133_64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.3327 15.0394H21.3342C21.011 15.0394 20.701 15.1678 20.4724 15.3964C20.2439 15.625 20.1155 15.9349 20.1155 16.2582V17.5472C20.1155 17.6172 20.1293 17.6864 20.156 17.751C20.1828 17.8156 20.222 17.8743 20.2714 17.9238C20.3209 17.9732 20.3796 18.0124 20.4442 18.0392C20.5088 18.066 20.5781 18.0797 20.648 18.0797H29.0152C29.0851 18.0797 29.1543 18.066 29.2189 18.0392C29.2836 18.0124 29.3423 17.9732 29.3917 17.9238C29.4411 17.8743 29.4804 17.8156 29.5071 17.751C29.5339 17.6864 29.5477 17.6172 29.5477 17.5472V16.2572C29.5474 15.9348 29.4194 15.6256 29.1917 15.3974C28.964 15.1691 28.6551 15.0404 28.3327 15.0394Z",
    fill: "#3A57FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.833 0C11.5786 0 0.833008 10.7456 0.833008 24C0.833008 37.2544 11.5786 48 24.833 48C38.0874 48 48.833 37.2544 48.833 24C48.833 10.7456 38.0874 0 24.833 0ZM37.958 32.4291C37.9573 33.1164 37.6839 33.7754 37.198 34.2615C36.7121 34.7476 36.0532 35.0212 35.3658 35.0222H14.3002C13.6128 35.0212 12.9539 34.7476 12.468 34.2615C11.9821 33.7754 11.7088 33.1164 11.708 32.4291V19.6059C11.709 18.9188 11.9824 18.26 12.4683 17.7741C12.9543 17.2882 13.613 17.0147 14.3002 17.0138H18.0558V16.2572C18.0558 15.3869 18.4015 14.5523 19.0169 13.937C19.6322 13.3216 20.4668 12.9759 21.3371 12.9759H28.3355C29.2057 12.9759 30.0403 13.3216 30.6557 13.937C31.2711 14.5523 31.6168 15.3869 31.6168 16.2572V17.0138H35.3724C36.0584 17.0165 36.7155 17.2907 37.2 17.7764C37.6845 18.2621 37.957 18.9199 37.958 19.6059V32.4291Z",
    fill: "#3A57FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_133_64"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.833008)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJob);
export default __webpack_public_path__ + "static/media/job.f60fae336548e54dd8d8d67a539ca761.svg";
export { ForwardRef as ReactComponent };